import type { IntlShape } from 'react-intl';

import { Option } from '~/types/Option';
import { Workflow } from '~/types/Workflow';

export const getWorkflowStatusLabels: (
  intl: IntlShape,
) => Record<string, string> = (intl) => ({
  draft: intl.formatMessage({
    id: 'WorkflowListPage.statusDraft',
    defaultMessage: 'Draft',
    description: 'Label for workflow status "Draft"',
  }),
  published: intl.formatMessage({
    id: 'WorkflowListPage.statusPublished',
    defaultMessage: 'Published',
    description: 'Label for workflow status "Published"',
  }),
  unpublished: intl.formatMessage({
    id: 'WorkflowListPage.statusUnpublished',
    defaultMessage: 'Unpublished',
    description: 'Label for workflow status "Unpublished"',
  }),
});

export const mapVersionCell = (
  workflow: Workflow,
  onClick: (option: Option<string>) => void,
  intl: IntlShape,
) => ({
  name: 'versions',
  options: [...workflow.versions]
    // the versions need to be sorted by newest first
    .sort((a, b) => b.number - a.number)
    .map((version) => ({
      label:
        (version.number === 0
          ? intl.formatMessage({
              id: 'WorkflowListPage.originalVersion',
              defaultMessage: 'Original',
              description: 'Label for the original version of a workflow',
            })
          : intl.formatMessage(
              {
                id: 'WorkflowListPage.versionNumber',
                defaultMessage: 'Version {number}',
                description:
                  'Label for workflow version with number. number is the version number (e.g., 1, 2, 3)',
              },
              { number: version.number },
            ) +
            (version.number === workflow.versionNumber
              ? intl.formatMessage({
                  id: 'WorkflowListPage.currentVersionSuffix',
                  defaultMessage: ' (Current)',
                  description: 'Suffix indicating the current version',
                })
              : '')) +
        (version.published
          ? intl.formatMessage({
              id: 'WorkflowListPage.publishedSuffix',
              defaultMessage: ' - Published',
              description: 'Suffix indicating a published version',
            })
          : ''),
      value: version.id,
      description: intl.formatMessage(
        {
          id: 'WorkflowListPage.versionDescription',
          defaultMessage: '{totalTickets} tickets ({activeTickets} active)',
          description:
            'Description showing total and active tickets count. totalTickets is the total number of tickets (e.g., 25), activeTickets is the number of active tickets (e.g., 12)',
        },
        {
          totalTickets: version.totalTickets,
          activeTickets: version.activeTickets,
        },
      ),
    })),
  onClick,
  text:
    workflow.versions.length > 1
      ? intl.formatMessage(
          {
            id: 'WorkflowListPage.multipleVersionsText',
            defaultMessage:
              '{count, plural, one {# version} other {# versions}}',
            description:
              'Text showing number of workflow versions. count is the number of versions (e.g., 3 versions)',
          },
          { count: workflow.versions.length },
        )
      : intl.formatMessage({
          id: 'WorkflowListPage.currentVersionText',
          defaultMessage: 'Current',
          description: 'Text for single current version',
        }),
});
